import apiAction from "../ajax/service"

const updateFormData = async (model , id , field , value) =>{
    const ret = await apiAction("forms",{modal:model,id,[field]:value},"update")
    return ret
}

export  {updateFormData}
